export const PLAN_PRICES = Object.freeze({
  "2weeks": 250,
  "1month": 400,
  "6months": 1500,
});

export const CUSTOMER_PLANS = Object.freeze({
  "2weeks": {
    id: "2weeks",
    name: "2 Weeks",
    tier: "Launch",
    days: 14,
    price: PLAN_PRICES["2weeks"],
    badge: "Fast start",
    limits: [
      ["Pool domains", "2"],
      ["Your own domains", "2"],
      ["Custom paths", "3"],
      ["Alias paths", "5"],
      ["Destinations", "Single"],
    ],
  },
  "1month": {
    id: "1month",
    name: "1 Month",
    tier: "Scale",
    days: 30,
    price: PLAN_PRICES["1month"],
    badge: "Most popular",
    featured: true,
    limits: [
      ["Pool domains", "3"],
      ["Your own domains", "4"],
      ["Custom paths", "5"],
      ["Alias paths", "Unlimited"],
      ["Destinations", "Up to 6"],
    ],
  },
  "6months": {
    id: "6months",
    name: "6 Months",
    tier: "Command",
    days: 180,
    price: PLAN_PRICES["6months"],
    badge: "Best value",
    bestValue: true,
    savings: PLAN_PRICES["1month"] * 6 - PLAN_PRICES["6months"],
    limits: [
      ["Pool domains", "5"],
      ["Your own domains", "6"],
      ["Custom paths", "Unlimited"],
      ["Alias paths", "Unlimited"],
      ["Destinations", "Up to 6"],
    ],
  },
});